/*
 * Copyright (c) 2024 яαvoroηα
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { AppStates } from '@definitions/storage'
import { configureStore, createAction, createReducer, Store } from '@reduxjs/toolkit'
import { STORAGE } from '@scripts/utils/constants'

const defaultState: AppStates = { menuVisible: false }

const menuToggle = createAction(STORAGE.ACTION_MENU_TOGGLE)
const menuHide = createAction(STORAGE.ACTION_MENU_HIDE)
const reducer = createReducer(defaultState, builder => {
    builder.addCase(menuToggle, state => {
        state.menuVisible = !state.menuVisible
    })

    builder.addCase(menuHide, state => {
        state.menuVisible = false
    })
})

const store: Store = configureStore({ reducer })

export { menuToggle }
export default store
